export const FOREGROUND = "#0A0A0A";
export const FOREGROUND_ALT = "#FAFAFA";

// null when the value isn't hex (rgb()/oklch()/garbage).
const parseHex = (color: string) => {
  const hex = color.trim().replace("#", "").slice(0, 6);
  const full = hex.length === 3 ? hex.replace(/./g, (c) => c + c) : hex;
  if (!/^[0-9a-f]{6}$/i.test(full)) return null;
  return [0, 2, 4].map((i) => Number.parseInt(full.slice(i, i + 2), 16));
};

// WCAG relative luminance.
const luminance = (rgb: number[]) => {
  const [r, g, b] = rgb.map((c) => {
    const v = c / 255;
    return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

/**
 * Foreground with the better contrast against `surface`. Falls back to
 * `fallback` when the surface color isn't a hex value we can read.
 * 0.18 is the crossover where FOREGROUND and FOREGROUND_ALT tie on contrast.
 *
 * ponytail: hand-rolled because CSS contrast-color() only returns pure
 * black/white and is Baseline-newly-available (Apr 2026) — too new to ship
 * unguarded on checkout. Swap it in once that's no longer true.
 */
export const contrastingForeground = (
  surface: string,
  fallback = FOREGROUND,
) => {
  const rgb = parseHex(surface);
  if (!rgb) return fallback;
  return luminance(rgb) > 0.18 ? FOREGROUND : FOREGROUND_ALT;
};

/** Foreground dimmed to 60% over the surface — an opaque color, not opacity. */
export const mutedFrom = (foregroundVar: string, surfaceVar: string) =>
  `color-mix(in srgb, var(${foregroundVar}) 60%, var(${surfaceVar}))`;
